import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthenticationStore } from "../../../stores/auth";
import { useApiClient } from "../../../api";

const LogoutPage = () => {
  const navigate = useNavigate();
  const apiClient = useApiClient();
  const { logOutUser } = useAuthenticationStore((state) => state);

  useEffect(() => {
    const logout = async () => {
      try {
        await apiClient.users.logout();
        logOutUser();

        navigate("/");
        window.location.reload();
      } catch (error) {
        console.error("Logout error:", error);
      }
    };

    // Call the logout function when the component mounts
    logout();
  }, [navigate, apiClient]);

  return (
    <div>
      <h1>Logging out...</h1>
      <p>Redirecting to the login page...</p>
    </div>
  );
};

export default LogoutPage;
